import React from 'react';

import { ProfileView } from './profile.view';

export const ProfileController = (): React.JSX.Element => {
  return <ProfileView />;
};
